import { JourneyKind } from 'interfaces/journey';

// Textos aprobados por producto (09/10).
export const savedDraftTitle = (journeyId: string) =>
  `Se guardó la ruta ${journeyId}.`;

export const savedDraftBody = (
  kind: JourneyKind | undefined,
  shipments: number,
  collections: number,
) => {
  const contents =
    kind === 'collections'
      ? `${collections} ${collections === 1 ? 'colecta' : 'colectas'}`
      : `${shipments} ${shipments === 1 ? 'envío' : 'envíos'}`;
  return `Ruta en preparación con ${contents}. Selecciona cómo continuar.`;
};
